import React, { useState } from "react";
import {
  Box,
  ToggleButtonGroup,
  ToggleButton,
  Typography,
} from "@mui/material";
import {
  ViewList as ViewListIcon,
  ViewModule as ViewModuleIcon,
  TableChart as TableChartIcon,
} from "@mui/icons-material";
import CampaignCardList from "./CampaignCardList";
import CampaignTable from "./CampaignTable";
import CampaignGridView from "./CampaignGridView";

export default function CampaignViewManager({
  campaigns,
  isLoading,
  error,
  onViewDetails,
  onEdit,
  onToggleStatus,
}) {
  const [viewMode, setViewMode] = useState("cards");

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setViewMode(newView);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Visualização:
          </Typography>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleViewChange}
            size="small"
            sx={{
              "& .MuiToggleButton-root": {
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                color: "grey.600",
                "&.Mui-selected": {
                  bgcolor: "#3483fa",
                  color: "white",
                  "&:hover": {
                    bgcolor: "#2968c8",
                  },
                },
              },
            }}
          >
            <ToggleButton value="cards">
              <ViewListIcon fontSize="small" />
            </ToggleButton>
            <ToggleButton value="grid">
              <ViewModuleIcon fontSize="small" />
            </ToggleButton>
            <ToggleButton value="table">
              <TableChartIcon fontSize="small" />
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>{" "}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {campaigns?.results?.length || 0} campanhas
          </Typography>
        </Box>
      </Box>

      <Box sx={{ mb: 3 }}>
        {viewMode === "cards" && (
          <CampaignCardList
            campaigns={campaigns}
            isLoading={isLoading}
            onViewDetails={onViewDetails}
            onEdit={onEdit}
            onToggleStatus={onToggleStatus}
          />
        )}

        {viewMode === "grid" && (
          <CampaignGridView
            campaigns={campaigns}
            isLoading={isLoading}
            onViewDetails={onViewDetails}
            onEdit={onEdit}
            onToggleStatus={onToggleStatus}
          />
        )}
        {viewMode === "table" && (
          <CampaignTable
            campaigns={campaigns}
            isLoading={isLoading}
            error={error}
            onViewDetails={onViewDetails}
            onEdit={onEdit}
          />
        )}
      </Box>
    </Box>
  );
}
